import { TableCell, TableRow } from "@mui/material";
import { amber } from "@mui/material/colors";
import { supplyCellStyles, supplyProductStyles } from "./supplyTableStyles";

const ghostCellSx = {
  borderTop: "2px dashed",
  borderBottom: "2px dashed",
  borderColor: "primary.main",
  bgcolor: amber[50],
};

function SupplyTableGhostRow({ item, suppliers, enabledDisplayRemarks }) {
  const supplyStyle = {
    ...(enabledDisplayRemarks
      ? supplyProductStyles.supplyWithRemarks
      : supplyProductStyles.supply),
    ...supplyCellStyles.leftBorder,
    ...ghostCellSx,
  };

  const displaySize =
    item.displaySize ||
    [item.rankName, item.productClassName, item.packingName]
      .filter(Boolean)
      .join(" ");

  const origin = item.originName || item.origin || "";
  const supplyUnitName = item.supplyUnitName || item.orderingUnit || "";

  return (
    <TableRow sx={{ verticalAlign: "middle", opacity: 0.6 }}>
      <TableCell sx={{ ...supplyProductStyles.dragHandle, ...ghostCellSx }} />
      <TableCell sx={{ ...supplyProductStyles.hideButton, ...ghostCellSx }} />
      <TableCell sx={{ ...supplyProductStyles.productName, ...ghostCellSx }}>
        {item.productName}
      </TableCell>
      <TableCell sx={{ ...supplyProductStyles.origin, ...ghostCellSx }}>
        {origin}
      </TableCell>
      <TableCell sx={{ ...supplyProductStyles.size, ...ghostCellSx }}>
        {displaySize}
      </TableCell>
      <TableCell sx={{ ...supplyProductStyles.supplyUnit, ...ghostCellSx }}>
        {supplyUnitName}
      </TableCell>
      {suppliers.map((supplier) => (
        <TableCell
          key={`ghost-${supplier.commodityOwnerName}`}
          sx={supplyStyle}
        />
      ))}
    </TableRow>
  );
}

export default SupplyTableGhostRow;
